import { DashboardCard } from '@/components/ui/dashboard-card.tsx';

export const TradeQueue = () => {
  const trades = [
    {
      id: 1,
      status: 'PENDING' as const,
      type: 'SELL' as const,
      amount: 150,
      price: 120.0,
      time: '15:00',
      source: 'Auto',
    },
    {
      id: 2,
      status: 'PENDING' as const,
      type: 'BUY' as const,
      amount: 300,
      price: 115.5,
      time: '16:00',
      source: 'Manual',
    },
    {
      id: 3,
      status: 'DONE' as const,
      type: 'SELL' as const,
      amount: 200,
      price: 119.5,
      time: '14:30',
      source: 'Auto',
    },
    {
      id: 4,
      status: 'DONE' as const,
      type: 'BUY' as const,
      amount: 400,
      price: 112.0,
      time: '13:00',
      source: 'Manual',
    },
  ];
  return (
    <DashboardCard>
      <div className="mb-4 text-base font-semibold">Trade Queue &amp; History</div>
      <table className="w-full border-collapse text-base">
        <thead>
          <tr className="border-b border-zinc-200">
            <th className="px-2 py-2 text-left font-medium text-zinc-500">Status</th>
            <th className="px-2 py-2 text-left font-medium text-zinc-500">Type</th>
            <th className="px-2 py-2 text-right font-medium text-zinc-500">Amount</th>
            <th className="px-2 py-2 text-right font-medium text-zinc-500">Price</th>
            <th className="px-2 py-2 text-left font-medium text-zinc-500">Time</th>
            <th className="px-2 py-2 text-left font-medium text-zinc-500">Source</th>
          </tr>
        </thead>
        <tbody>
          {trades.map((trade) => (
            <tr key={trade.id} className="border-b border-zinc-100">
              <td className="px-2 py-2">
                <span
                  className={[
                    'rounded px-2.5 py-0.5 text-[11px] font-semibold',
                    trade.status === 'PENDING'
                      ? 'bg-blue-100 text-blue-900'
                      : 'bg-green-100 text-green-800',
                  ].join(' ')}
                >
                  {trade.status}
                </span>
              </td>
              <td
                className={[
                  'px-2 py-2 font-semibold',
                  trade.type === 'BUY' ? 'text-blue-500' : 'text-green-500',
                ].join(' ')}
              >
                {trade.type}
              </td>
              <td className="px-2 py-2 text-right">{trade.amount} kW</td>
              <td className="px-2 py-2 text-right">€{trade.price.toFixed(2)}</td>
              <td className="px-2 py-2">{trade.time}</td>
              <td className="px-2 py-2 text-zinc-500">{trade.source}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </DashboardCard>
  );
};

export default TradeQueue;
